'use client'

import { useCallback } from 'react'
import { useSound } from '../hooks/useSound'

/**
 * Sound mute/unmute toggle — floating bottom-left
 * Minimal: just a pulsing dot when active
 */
export default function SoundToggle() {
  const { isEnabled, toggle, playTick } = useSound()

  const handleClick = useCallback(() => {
    toggle()
    playTick()
  }, [toggle, playTick])

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-10 left-10 z-100 flex items-center gap-2.5 group opacity-60 hover:opacity-100 transition-opacity duration-300"
      style={{ padding: '15px 10px' }}
      data-cursor-label={isEnabled ? 'Mute' : 'Sound'}
      aria-label={isEnabled ? 'Mute sound' : 'Enable sound'}
    >
      {/* Audio bars visualization (spans — <button> only allows phrasing content) */}
      <span className="flex items-end gap-[3px] h-3.5">
        {[0.5, 1.0, 0.7, 0.9].map((h, i) => (
          <span
            key={i}
            className="block w-[2px] rounded-full transition-all duration-300"
            style={{
              height: isEnabled ? `${h * 100}%` : '25%',
              backgroundColor: isEnabled ? 'var(--color-fire)' : 'var(--color-fog)',
              animation: isEnabled ? `audioBar ${0.5 + i * 0.1}s ${i * 0.12}s ease-in-out infinite alternate` : 'none',
            }}
          />
        ))}
      </span>

      {/* Label */}
      <span className="font-mono text-[9px] uppercase tracking-[0.2em] text-fog group-hover:text-mist transition-colors duration-300">
        {isEnabled ? 'on' : 'off'}
      </span>
    </button>
  )
}
